import { makeStyles } from '@material-ui/core/styles'
import { themeCommon } from '../../theme'

const useStyles = makeStyles((theme) => ({
    rootTableContainer: {
        boxShadow: 'none',
    },
    rootTableCell: {
        fontFamily: themeCommon.RobotoBold,
        color: 'rgba(0, 0, 0, 0.54)',
        borderBottom: 'unset',
        padding: '6px 10px',
        fontSize: themeCommon.fontSize14px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize12px,
            padding: '6px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize10px,
        }
    },
    headTableCell: {
        lineHeight: 'unset',
        paddingLeft: '15px',
    },
    rootTableCellStatus: {
        color: themeCommon.lightBlue,
    },
    rootTableCellStatusMissed: {
        color: themeCommon.lightRed,
    },
    rootTableCellStatusExprired: {
        color: themeCommon.lightRed,
        // pointerEvents: 'none',
    },
    rootTableCellCoinMissed: {
        opacity: '0.6',
    },
    rootAccordion: {
        boxShadow: 'none', 
        width: '100%',
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px !important',
        '&:hover': {
            background: themeCommon.lightBlue,
            color: 'white',
        },
        '&:hover $rootTypographyHover': {
            color: 'white',
        },
        '&:hover $rootTableCellStatusExprired': {
            color: themeCommon.lightRed,
        },
    },
    rootAccordionSummary: {
    },
    rootAccordionStatusExprired: {
        '& .MuiButtonBase-root': {
            cursor: 'no-drop !important',
        },
    },
    rootTypography: {
        color: '#C1C1C1',
    },
    rootTypographyHover: {
        fontSize: themeCommon.fontSize16px,
        [theme.breakpoints.down('lg')]: {
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize13px,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px,
        },
    },
}), {
    name: 'SurveyHolderHeadContainer',
    index: 1,
})

export default useStyles